import { useCallback, useMemo } from 'react';
import { useUserInfo } from './useUserInfo';
const EMPTY_SCOPES = new Set();
export const useGetHasScope = () => {
  const userInfo = useUserInfo();
  const userInfoScopes = useMemo(() => {
    if (!userInfo) {
      return EMPTY_SCOPES;
    }

    const {
      user
    } = userInfo;

    if (!user) {
      return EMPTY_SCOPES;
    }

    const {
      scopes
    } = user;
    return new Set(scopes);
  }, [userInfo]);
  const hasScope = useCallback(scope => {
    return userInfoScopes.has(scope);
  }, [userInfoScopes]);
  return {
    hasScope,
    loading: !userInfo
  };
};